import _ from 'lodash';
import React from 'react';
import { decorate, computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';

import ScEnvironmentRdpConnectionRow from './ScEnvironmentRdpConnectionRow';

// expected props
// - environment (via prop)
class ScEnvironmentRdpConnections extends React.Component {
  get environment() {
    return this.props.scEnvironment;
  }

  get connections() {
    const connections = this.environment.getConnections(item => item.scheme === 'rdp');
    return connections;
  }

  get isAppStreamEnabled() {
    return process.env.REACT_APP_IS_APP_STREAM_ENABLED === 'true';
  }

  render() {
    const env = this.environment;
    const state = env.state;
    const canConnect = state.canConnect;
    const empty = _.isEmpty(this.connections);

    if (!canConnect) return null;
    let content = null;

    if (empty) {
      content = this.renderEmpty();
    } else {
      content = this.renderConnections();
    }

    return <div className="fadeIn animated">{content}</div>;
  }

  renderAppstreamInstructions() {
    return (
      this.isAppStreamEnabled && (
        <div className="connection-info-box" data-testid="appstream-instructions-rdp">
          <Icon name="info circle" />
          <div className="connection-info-box-content">
            <b>AppStream Connection Instructions:</b>
            <ul>
              <li>Click "Get Password" to retrieve your credentials</li>
              <li>Copy the credentials and click "Connect"</li>
              <li>Paste the credentials in the AppStream RDP login page</li>
            </ul>
          </div>
        </div>
      )
    );
  }

  renderConnections() {
    const env = this.environment;
    const connections = this.connections;

    return (
      <div className="connection-card">
        <div className="connection-card-header">
          <div className="connection-card-title">
            <Icon name="desktop" />
            Remote Desktop (RDP/DCV)
          </div>
        </div>
        <div className="connection-card-body">
          <div className="connection-intro">
            This connects you to a Windows desktop on your workspace. Click <b>Get Password</b> to retrieve your
            login credentials, then use an RDP client or DCV to connect. You can copy and paste between your
            local machine and the remote desktop.
          </div>
          {this.renderAppstreamInstructions()}
          {_.map(connections, item => (
            <ScEnvironmentRdpConnectionRow
              key={item.id}
              scEnvironment={env}
              connectionId={item.id}
              isDcvEnabled={this.props.isDcvEnabled}
            />
          ))}
          <div className="connection-help-link">
            <Icon name="question circle outline" style={{ margin: 0, lineHeight: 1, height: '1em' }} />
            Need help? Visit the <a href="/documentation">Documentation</a> for detailed guides.
          </div>
        </div>
      </div>
    );
  }

  renderEmpty() {
    return (
      <div className="connection-card">
        <div className="connection-empty">
          <Icon name="desktop" />
          <div className="connection-empty-title">No RDP Connections</div>
          <div className="connection-empty-text">This workspace does not have any RDP connections.</div>
        </div>
      </div>
    );
  }
}

decorate(ScEnvironmentRdpConnections, {
  environment: computed,
  connections: computed,
});

export default inject()(withRouter(observer(ScEnvironmentRdpConnections)));
